/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Manage_Permissions_TitleInputs */

const en_admin_roles_manage_permissions_title = /** @type {(inputs: Admin_Roles_Manage_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Role Permissions`)
};

const zh_admin_roles_manage_permissions_title = /** @type {(inputs: Admin_Roles_Manage_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理角色权限`)
};

/**
* | output |
* | --- |
* | "Manage Role Permissions" |
*
* @param {Admin_Roles_Manage_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_manage_permissions_title = /** @type {((inputs?: Admin_Roles_Manage_Permissions_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Manage_Permissions_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_manage_permissions_title(inputs)
	return zh_admin_roles_manage_permissions_title(inputs)
});
export { admin_roles_manage_permissions_title as "admin.roles.manage_permissions_title" }